import {stage} from './stage';

// This application's OWN hosts, per stage — distinct from platform.ts,
// which says where the platform's OTHER applications live.
//
// Each deployed host is the apex of its own zone (`dev.flexi.directory`,
// `test.flexi.directory`, `flexi.directory`), made in the Flexi Domains app
// and aliased to the stage's CloudFront distribution by
// flexinet-directory-app-infra. The same layout as Flexi Email.
//
// The `ide` port must match `server.port` in vite.config.ts (8027) and
// the VITE_APP_URL in .env.development.local. All three move together.
const hosts = {
    prod: {
        url: 'https://flexi.directory',
    },
    test: {
        url: 'https://test.flexi.directory',
    },
    dev: {
        url: 'https://dev.flexi.directory',
    },
    ide: {
        url: 'https://localhost:8027',
    },
};

export default hosts[stage] ?? hosts.dev;
